import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/hitechvn/web-user/node_modules/@ant-design/nextjs-registry/es/AntdRegistry.js");
;
import(/* webpackMode: "eager" */ "/opt/hitechvn/web-user/node_modules/next/font/google/target.css?{\"path\":\"src/app/layout.jsx\",\"import\":\"Inter\",\"arguments\":[{\"subsets\":[\"latin\"],\"variable\":\"--font-inter\",\"display\":\"swap\"}],\"variableName\":\"inter\"}");
;
import(/* webpackMode: "eager" */ "/opt/hitechvn/web-user/src/app/globals.css");
;
import(/* webpackMode: "eager" */ "/opt/hitechvn/web-user/node_modules/aos/dist/aos.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/hitechvn/web-user/src/components/layouts/Index.jsx");
;
import(/* webpackMode: "eager" */ "/opt/hitechvn/web-user/src/styles/globals.scss");
;
import(/* webpackMode: "eager" */ "/opt/hitechvn/web-user/src/styles/embla.scss");
